import PropTypes from 'prop-types';
import { noop } from 'lodash';
import {
    propTypes as toggleablePropTypes,
    defaultProps as toggleableDefaultProps,
} from 'containers/Toggleable';

export const itemPropTypes = {
    value: PropTypes.string.isRequired,
    label: PropTypes.node,
    disabled: PropTypes.bool,
};

export const itemDefaultProps = {
    label: '',
    disabled: false,
};

export const sectionPropTypes = {
    section: PropTypes.string.isRequired,
    emptyLabel: PropTypes.node,
    isLoading: PropTypes.bool,
    loadingText: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape(itemPropTypes)),
};

export const valuePropTypes = PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.shape(itemPropTypes),
    PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.shape(itemPropTypes)]),
    ),
]);

export const sectionsOrItemsPropType = PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape(itemPropTypes)),
    PropTypes.arrayOf(PropTypes.shape(sectionPropTypes)),
]);

export const propTypes = {
    ...toggleablePropTypes,
    id: PropTypes.string,
    items: sectionsOrItemsPropType.isRequired,
    value: valuePropTypes,
    placeholder: PropTypes.string,
    clearItemLabel: PropTypes.string,
    emptyLabel: PropTypes.node,
    tabIndex: PropTypes.number,
    isLoading: PropTypes.bool,
    loadingText: PropTypes.string,
    selectAllText: PropTypes.node,
    disabled: PropTypes.bool,
    separated: PropTypes.bool,
    fullWidth: PropTypes.bool,
    usePortal: PropTypes.bool,
    multiple: PropTypes.bool,
    showSelectedCount: PropTypes.bool,
    allowSelectAll: PropTypes.bool,
    selectedItemsText: PropTypes.string,
    renderToggle: PropTypes.func,
    renderItem: PropTypes.func,
    renderSelection: PropTypes.func,
    renderSelectableItemDecorator: PropTypes.func,
    filterItems: PropTypes.func,
    itemToString: PropTypes.func,
    onSelect: PropTypes.func,
    onHighlight: PropTypes.func,
    onKeyDown: PropTypes.func,
    onClick: PropTypes.func,
    onFocus: PropTypes.func,
    menuClassName: PropTypes.string,
    toggleClassName: PropTypes.string,
    dropdownClassName: PropTypes.string,
    checkboxClassName: PropTypes.string,
    containerClassName: PropTypes.string,
    className: PropTypes.string,
    onBeforeSelect: PropTypes.func,
};

export const defaultProps = {
    ...toggleableDefaultProps,
    id: '',
    value: '',
    placeholder: null,
    selectAllText: null,
    clearItemLabel: null,
    emptyLabel: null,
    tabIndex: 0,
    isLoading: false,
    loadingText: null,
    disabled: false,
    separated: false,
    fullWidth: true,
    usePortal: true,
    multiple: false,
    showSelectedCount: false,
    allowSelectAll: false,
    selectedItemsText: null,
    renderToggle: noop,
    renderItem: noop,
    renderSelection: noop,
    renderSelectableItemDecorator: noop,
    filterItems: noop,
    itemToString: noop,
    onSelect: noop,
    onHighlight: noop,
    onKeyDown: noop,
    onClick: noop,
    onFocus: noop,
    menuClassName: null,
    toggleClassName: null,
    dropdownClassName: null,
    checkboxClassName: null,
    containerClassName: null,
    className: null,
    onBeforeSelect: noop,
};
